export const environment = {
  production: false,
  apiUrl: 'https://stage.axenta.cloud/api/',
  websocketUrl: 'wss://stage.axenta.cloud/ws/',
  locales: ['en', 'ru'],
  defaultLocale: 'en',
  systemType: 'monitoring',
};
